import { IdentifyProgressBar } from '../../../../../components';
import CaptureFrontLogic from '../_containers/capture-front-logic';

export default function CaptureFrontPage() {
  return (
    <div className='flex h-dvh w-full flex-col items-center'>
      <IdentifyProgressBar currentStep={1} />
      <CaptureFrontLogic />
    </div>
  );
}
